import React, { Component } from "react";
import ErrorScreen from "components/ErrorScreen/ErrorScreen";

export default class Error404 extends Component {
  render() {
    return <ErrorScreen title={"PAGE NOT FOUND"} imageUrl={""} />;
  }
}
